import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';

// PrimeVue styles
import 'primevue/resources/themes/lara-light-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

import App from './App.vue';
import router from './router';

import './assets/main.css'
import './assets/dashboard.css';

// PrimeVue components
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Password from 'primevue/password';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Card from 'primevue/card';
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import FileUpload from 'primevue/fileupload';
import ProgressBar from 'primevue/progressbar';
import Textarea from 'primevue/textarea';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import Calendar from 'primevue/calendar';
import Message from 'primevue/message';
import Skeleton from 'primevue/skeleton';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import Divider from 'primevue/divider';
import Badge from 'primevue/badge';
import Chip from 'primevue/chip';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Sidebar from 'primevue/sidebar';
import ProgressSpinner from 'primevue/progressspinner';
import Tooltip from 'primevue/tooltip';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(PrimeVue, { ripple: true });
app.use(ToastService);
app.use(ConfirmationService);

// Register components globally
app.component('Button', Button);
app.component('InputText', InputText);
app.component('InputNumber', InputNumber);
app.component('Password', Password);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('Dialog', Dialog);
app.component('Dropdown', Dropdown);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Card', Card);
app.component('Tag', Tag);
app.component('Toast', Toast);
app.component('ConfirmDialog', ConfirmDialog);
app.component('FileUpload', FileUpload);
app.component('ProgressBar', ProgressBar);
app.component('Textarea', Textarea);
app.component('Checkbox', Checkbox);
app.component('RadioButton', RadioButton);
app.component('Calendar', Calendar);
app.component('Message', Message);
app.component('Skeleton', Skeleton);
app.component('Paginator', Paginator);
app.component('Panel', Panel);
app.component('Divider', Divider);
app.component('Badge', Badge);
app.component('Chip', Chip);
app.component('Menu', Menu);
app.component('Menubar', Menubar);
app.component('Sidebar', Sidebar);
app.component('ProgressSpinner', ProgressSpinner);

// Directives
app.directive('tooltip', Tooltip);

app.mount('#app');
